export default "__VITE_ASSET__C5yYR1g7__"